module.exports = "/images/Small Business-M.jpg";